import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectReleaseTitle } from 'services/store/distribution/selectors';

type PropsType = {
  releaseId: string;
};

const ReleaseTitle = ({ releaseId }: PropsType) => {
  const { t } = useTranslation();

  const releaseTitle = useSelector(selectReleaseTitle(releaseId));
  const { data } = releaseTitle;

  return (
    <TextField
      fullWidth
      disabled
      label={t(`distribution:details:fields:releaseTitle:placeholder`)}
      defaultValue={data}
    />
  );
};

export default ReleaseTitle;
